let regular = {
  /* 大于 0 的数字正则校验 */
  greaterThanZero (rule, value, callback) {
    if (value !== '') {
      if ((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value) === false) {
        callback(new Error('请填写大于0的数字'))
      } else {
        callback()
      }
    } else {
      callback()
    }
  },
  /* 英文名称正则名称 */
  englishName (rule, value, callback) {
    if (/[^\w_]/g.test(value)) {
      callback(new Error('只能输入英文字符数字和下划线'))
    } else if (value.length > 50) {
      callback(new Error('英文字符长度在0到50之间'))
    } else {
      callback()
    }
  },
  /* 电话号码校验 */
  phone (rule, value, callback) {
    if (value !== '') {
      if ((/^1[3|4|5|6|7|8|9][0-9]\d{8}$/).test(value) === false) {
        callback(new Error('请填写正确的号码'))
      } else {
        callback()
      }
    } else {
      callback()
    }
  },
  /* 邮箱校验 */
  email (rule, value, callback) {
    if (value !== '') {
      if ((/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/).test(value) === false) {
        callback(new Error('请填写正确的邮箱'))
      } else {
        callback()
      }
    } else {
      callback()
    }
  }
}
export default regular



// WEBPACK FOOTER //
// ./src/config/regular.js